import { ProjectLockResponse, ProjectLockListResponse, CreateProjectLockRequest, UpdateProjectLockRequest } from "@/types/projectLockTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class ProjectLockFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAll(): Promise<ProjectLockListResponse> {
    return this.client.read('/api/project-locks');
  }

  readByProjectIds(projectIds: string[]): Promise<ProjectLockListResponse> {
    return this.client.create('/api/project-locks/by-project-ids', { projectIds });
  }

  create(data: CreateProjectLockRequest): Promise<ProjectLockResponse> {
    return this.client.create('/api/project-locks', data);
  }

  update(id: string, data: UpdateProjectLockRequest): Promise<ProjectLockResponse> {
    return this.client.update(`/api/project-locks/${id}`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/project-locks/${id}`);
  }
}
